// The hike show page renders only its gallery's first photo link, carrying a
// data-gallery-url; the rest of the photos are fetched from there the first
// time the gallery is opened. Rendering them all inline cost one hidden
// signed-URL link per photo — 349 of them, ~200KB of HTML, for Wicklow Way.
//
// lightbox2 builds its album from every a[data-lightbox="<group>"] in the DOM
// when a link is clicked, so once the links are appended after the first one
// a re-click opens the full gallery.

export function galleryUrlsFrom(payload: unknown): string[] {
  if (!payload || typeof payload !== 'object') return [];

  const urls = (payload as { urls?: unknown }).urls;
  if (!Array.isArray(urls)) return [];

  return urls.filter((url): url is string => typeof url === 'string' && url.trim() !== '');
}

export function appendGalleryLinks(anchor: HTMLAnchorElement, urls: string[]): void {
  let previous: Element = anchor;
  urls.forEach((url) => {
    const link = document.createElement('a');
    link.href = url;
    link.dataset.lightbox = anchor.dataset.lightbox ?? '';
    link.style.display = 'none';
    previous.after(link);
    previous = link;
  });
}

export function setupLazyLightboxGallery(root: ParentNode = document): void {
  root.querySelectorAll<HTMLAnchorElement>('a[data-gallery-url]').forEach((anchor) => {
    let state: 'idle' | 'loading' | 'loaded' = 'idle';

    anchor.addEventListener('click', (event) => {
      // Loaded: let lightbox2's delegated body handler open the album.
      if (state === 'loaded') return;

      event.preventDefault();
      event.stopPropagation();
      if (state === 'loading') return;

      state = 'loading';
      fetch(anchor.dataset.galleryUrl as string, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then((response) => (response.ok ? response.json() : null))
        .then((payload) => appendGalleryLinks(anchor, galleryUrlsFrom(payload)))
        // A failed fetch still opens the first photo rather than doing nothing.
        .catch(() => undefined)
        .finally(() => {
          state = 'loaded';
          anchor.click();
        });
    });
  });
}
